<template><slot :docid :doctype="doctype" :identity="identity" :splitter="splitter"></slot></template>
<script>
import Store from 'stores/overview/purchase/store';

export default {
    props: {
        doctype: {
            type: String,
            required: true,
        },
        docid: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        identity() {
            return {
                type: this.doctype,
                id: this.docid,
            };
        },
        splitter() {
            return new RegExp('\\?_f=purchases_' + this.doctype + 'Overview&id=(\\d+)');
        },
    },
    created() {
        this.$store.registerModule('purOverview', Store);
    },
};
</script>
